import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '@/core/config/routes';
import { LoginRequestSchema } from '@/data/dto/auth';
import { useLogin } from '@/data/hooks/useAuth';
import { AppError } from '@/core/errors/AppError';
import { Button } from '@/shared/components/Button';
import { Checkbox } from '@/shared/components/Checkbox';
import { Field } from '@/shared/components/Field';
import { Input } from '@/shared/components/Input';
import { PasswordInput } from '@/shared/components/PasswordInput';
import { useToast } from '@/shared/components/Toast';
export function LoginForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = location.state?.redirectTo ?? ROUTES.dashboard;
    const toast = useToast();
    const { register, handleSubmit, formState: { errors }, setError, } = useForm({
        resolver: zodResolver(LoginRequestSchema),
        defaultValues: { email: '', password: '', recordarme: true },
    });
    const { mutate, isPending } = useLogin();
    const onSubmit = (datos) => {
        mutate(datos, {
            onSuccess: () => navigate(redirectTo, { replace: true }),
            onError: (err) => {
                if (err instanceof AppError) {
                    if (err.codigo === 'AUTH_CREDENCIALES_INVALIDAS') {
                        setError('password', { message: 'Usuario o contraseña incorrectos' });
                        return;
                    }
                    toast.error(err.mensaje, err.requestId ? `ID: ${err.requestId}` : undefined);
                    return;
                }
                toast.error('No pudimos ingresar. Reintentá.');
            },
        });
    };
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "flex flex-col gap-4", noValidate: true, children: [_jsx(Field, { label: "Email", htmlFor: "email", error: errors.email?.message, required: true, children: _jsx(Input, { id: "email", type: "email", autoComplete: "username", autoFocus: true, error: Boolean(errors.email), ...register('email') }) }), _jsx(Field, { label: "Contrase\u00F1a", htmlFor: "password", error: errors.password?.message, required: true, children: _jsx(PasswordInput, { id: "password", autoComplete: "current-password", error: Boolean(errors.password), ...register('password') }) }), _jsxs("div", { className: "flex items-center justify-between", children: [_jsx(Checkbox, { id: "recordarme", label: "Recordarme", ...register('recordarme') }), _jsx(Link, { to: ROUTES.recuperar, className: "text-sm font-medium text-primary hover:underline", children: "\u00BFOlvidaste tu contrase\u00F1a?" })] }), _jsx(Button, { type: "submit", cargando: isPending, size: "lg", className: "w-full", children: "Ingresar" })] }));
}
